
interface NavIconProps{
	icon?: string
	iconPath?: string
	iconText?: string
}

export const NavIcon = ({ item } : { item : NavIconProps}) => {
	if (item.icon) {
		return (
			<div className='item-icon text-middle'>{item.icon}</div>
		)
	} else if (item.iconPath){
		return <img src={item.iconPath} className='nav-item-icon-img'/>
	} else if (item.iconText) {
		return (
			<span className='item-icon icon-text'>{item.iconText}</span>
		)
	} else {
		return (
			<span className='item-icon icon-text'></span>
		)
	}
}